import React from 'react';
import { HiOutlineCheckCircle, HiOutlineXCircle, HiOutlineShieldExclamation } from 'react-icons/hi2';

const Step2_SafetyReview = ({ incidentData, readOnly = false }) => {
  if (!incidentData) return null;

  return (
    <div className="bg-card p-6 rounded-md border border-gray-200 shadow-sm max-w-4xl mx-auto my-0">
      <div className="border-b border-gray-200 pb-4 mb-6 flex items-start justify-between">
        <div>
          <h2 className="text-md font-bold text-primary flex items-center gap-2">
            <HiOutlineShieldExclamation className="w-6 h-6 text-yellow-600" />
            Safety Office Review
          </h2>
          <p className="text-sm text-gray-400 font-normal mt-0.5 mt-1">Review the First Incident Report and determine if a formal investigation is required.</p>
        </div>
        <div className="bg-yellow-50 text-yellow-800 border border-yellow-200 px-3 py-1 rounded-md text-[12px] font-semibold">
          Status: {incidentData.currentStep > 2 ? 'Approved' : 'Pending Review'}
        </div>
      </div>

      <div className="space-y-6">
        <div className="bg-page-bg p-4 rounded-lg border border-gray-200">
          <h3 className="font-semibold text-primary mb-2 text-[15px]">Instructions for Safety Officer:</h3>
          <ul className="list-disc list-inside text-[14px] text-secondary space-y-1 ">
            <li>Review the FIR details submitted in Step 1.</li>
            <li>Verify the Incident Type ({incidentData.type}) is correctly categorized.</li>
            <li>Determine if the severity warrants a full Root Cause Analysis (Steps 3-5).</li>
            <li>Provide any immediate comments or feedback.</li>
          </ul>
        </div>

        <div>
          <label className="block text-[14px] font-medium text-secondary mb-1">Safety Officer Comments</label>
          <textarea
            rows={4}
            className="w-full rounded-md p-2 border-[1px]  border-gray-300 shadow-sm focus:border-primary-500 focus:ring-primary-500 sm:text-base bg-card"
            placeholder="Enter review notes, justifications for approval/rejection, or requests for more information..."
            readOnly={readOnly}
            defaultValue={incidentData.currentStep > 2 ? "Incident report reviewed and accepted. Full investigation is required based on the severity matrix." : ""}
          />
        </div>

        {!readOnly && (
          <div className="flex justify-end gap-4 pt-4 border-t border-gray-200">
            <button className="px-4 py-2 bg-card border border-red-300 text-red-700 hover:bg-red-50 font-medium rounded-lg transition-colors flex items-center gap-2 shadow-sm">
              <HiOutlineXCircle className="w-5 h-5" />
              Reject / Request Changes
            </button>
            <button
              className="px-4 py-2 text-white font-medium rounded-lg transition-colors flex items-center gap-2 shadow-sm"
              style={{ backgroundColor: '#509183' }}
              onMouseEnter={e => e.currentTarget.style.backgroundColor = '#3d7268'}
              onMouseLeave={e => e.currentTarget.style.backgroundColor = '#509183'}
            >
              <HiOutlineCheckCircle className="w-5 h-5" />
              Approve FIR & Proceed to Investigation
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default Step2_SafetyReview;
